"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageTagMatcher = void 0;
const LanguageTagParser_1 = require("./LanguageTagParser");
/**
 * The Matcher provides an algorithm to find the best matching IETF language tag.
 * For a given IETF language tag, a list of IETF language tags supported by another application is searched for the best match.
 */
class LanguageTagMatcher {
    /**
     * Constructor
     *
     * @param availableLanguageTags List of IETF language tags supported by another application.
     * @param defaultLanguageTag The default IETF language tag that should be used if no match is found.
     */
    constructor(availableLanguageTags, defaultLanguageTag) {
        this.availableLanguageTags = availableLanguageTags;
        this.defaultLanguageTag = defaultLanguageTag;
    }
    /**
     * Returns the best matching IETF language tag of the available IETF language tags.
     *
     * The following steps are performed:
     *  - return the given IETF language tag if it is in the list of available IETF language tags
     *  - return the first IETF language tag with the same language
     *  - return the first IETF language tag with the same country
     *  - return the default IETF language tag
     */
    findBestMatch(languageTag) {
        if (languageTag) {
            // 1. try to return 1:1 if IETF language tag is available
            let matchedLanguageTag = this.firstMatch(languageTag);
            if (matchedLanguageTag)
                return matchedLanguageTag;
            // 2. try to return first IETF language tag with same language
            matchedLanguageTag = this.firstMatchByLanguage(LanguageTagParser_1.LanguageTagParser.getLanguageFromLanguageTag(languageTag));
            if (matchedLanguageTag)
                return matchedLanguageTag;
            // 3. try to return first IETF language tag with same country
            matchedLanguageTag = this.firstMatchByCountry(LanguageTagParser_1.LanguageTagParser.getCountryFromLanguageTag(languageTag));
            if (matchedLanguageTag)
                return matchedLanguageTag;
        }
        // 4. return default if nothing matches
        return this.defaultLanguageTag;
    }
    firstMatch(languageTag) {
        return this.availableLanguageTags.find((x) => x === languageTag);
    }
    firstMatchByLanguage(languageSubtag) {
        return this.availableLanguageTags.find((x) => LanguageTagParser_1.LanguageTagParser.getLanguageFromLanguageTag(x) === languageSubtag);
    }
    firstMatchByCountry(country) {
        return this.availableLanguageTags.find((x) => LanguageTagParser_1.LanguageTagParser.getCountryFromLanguageTag(x) === country);
    }
}
exports.LanguageTagMatcher = LanguageTagMatcher;
//# sourceMappingURL=LanguageTagMatcher.js.map